import React from 'react';

import { Stack, Typography } from '@mui/material';

import { Button } from '@/components/NewUI/ComponentsLibrary';
import { withScoutTheme } from '@/components/ThemeContext/ThemeContext';

interface Props {
  authenticityToken: string;
  entityName: string;
  unsubscribeUrl: string;
}

const styles = {
  page: {
    alignItems: 'center',
    padding: 5
  },
  content: {
    alignItems: 'center',
    maxWidth: '640px',
    rowGap: 3,
    textAlign: 'center'
  },
  form: {
    margin: 0
  }
};

const SeekVerificationUnsubscribe = ({ entityName, unsubscribeUrl, authenticityToken }: Props) => (
  <Stack className="container" sx={styles.page}>
    <Stack className="center" sx={styles.content}>
      <Typography component="h4" variant="h4">
        Are you sure you want to stop receiving identity verification emails from {entityName}?
      </Typography>

      <Stack
        action={unsubscribeUrl}
        className="button_to mb-3"
        component="form"
        method="post"
        sx={styles.form}
      >
        <Button buttonVariant="primary" id="seek-verification-unsubscribe-button" type="submit">
          Unsubscribe
        </Button>
        <input name="authenticity_token" type="hidden" value={authenticityToken} />
      </Stack>
    </Stack>
  </Stack>
);

export default withScoutTheme(SeekVerificationUnsubscribe);
